{
  "schemaVersion": "cogo.ux-pattern-definition.v1",
  "uxPatternId": "newsletter-operator-overview",
  "version": "1.0.0",
  "target": "web",
  "intent": "Review the membership roster and focus one member",
  "actorContext": "newsletter-operator",
  "requiredCapabilities": ["select-operator-member", "read-membership-roster"],
  "preconditions": ["roster-available"],
  "postconditions": ["member-focused"],
  "states": [
    { "stateId": "browsing", "statusIntent": "idle" },
    { "stateId": "member-selected", "statusIntent": "success" }
  ],
  "transitions": [
    {
      "transitionId": "select",
      "fromState": "browsing",
      "eventRef": "select-member",
      "toState": "member-selected",
      "effectRefs": ["focus-current-member"],
      "emitEventRefs": ["operator-member-selected"]
    }
  ],
  "ports": [
    { "portId": "select-member", "kind": "event", "direction": "in", "valueType": "cogo.member-id", "required": false },
    { "portId": "operator-member-selected", "kind": "event", "direction": "out", "valueType": "cogo.member-id", "required": true }
  ],
  "semanticNodes": [
    {
      "nodeId": "membership-roster",
      "semanticRole": "membership-roster",
      "regionRef": "roster",
      "content": { "title": "Membership overview" },
      "visibleIn": ["browsing", "member-selected"]
    },
    {
      "nodeId": "select-member",
      "semanticRole": "primary-action",
      "regionRef": "decision",
      "content": { "label": "Select member" },
      "visibleIn": ["browsing"],
      "action": { "role": "primary", "capabilityRef": "select-operator-member", "slotRef": "decision-primary" }
    }
  ],
  "lineage": {
    "authorityStatus": "consumer-verified",
    "sourceKind": "human-authored-canonical",
    "sourceRefs": ["cogo:approved-source/newsletter-operator-overview-v1"]
  }
}
